import { useCallback, useEffect, useState } from "react";
import { useFetch } from "@hooks/useFetch";
import { getPaymentMethodListApiRoute } from "@api-routes/eirStancerFacade";
import { getResponseToState, IPaymentMethodResponse } from "./mappers/getPaymentMethodListMapper";
import { IPaymentMethod } from "@features/summary/interface/IPaymentMethod";

interface IParams {
    isNewPaymentProvider: boolean | undefined;
}

export const useAuthPaymentIframe = (props: IParams) => {
    const { isNewPaymentProvider } = props;
    const [paymentMethodListFetchState, { get }] = useFetch();
    const [paymentMethodList, setPaymentMethodList] = useState<IPaymentMethod[]>();

    const getPaymentMethodList = useCallback(() => {
        if (isNewPaymentProvider) {
            get<IPaymentMethodResponse[]>(getPaymentMethodListApiRoute(), { forwardError: true }).then(
                (paymentMethodListResponse) => {
                    if (paymentMethodListResponse) {
                        setPaymentMethodList(getResponseToState(paymentMethodListResponse));
                    }
                }
            );
        }
    }, [get, isNewPaymentProvider]);

    useEffect(() => {
        getPaymentMethodList();
    }, [getPaymentMethodList]);

    return {
        getPaymentMethodList,
        paymentMethodListFetchState,
        paymentMethodList,
    };
};
